import { Button, Dialog, icons } from '@portal/components'
import React, { useState } from 'react'

import { useDQLEditorContext } from '../dqlEditor/context'
import FeatureHighlight from './FeatureHighlight'

const { Asterisk, Lightning, Filter } = icons

const LOCALE_STORAGE_KEY = 'initialDQLEditorPreviewOverlaySeen'

export default function InitialPreviewOverlay() {
  const { showLatestTour, setShowLatestTour } = useDQLEditorContext()

  const [isDefaultOpen, setIsDefaultOpen] = useState(
    localStorage.getItem(LOCALE_STORAGE_KEY) !== 'true',
  )

  const handleGetStarted = () => {
    localStorage.setItem(LOCALE_STORAGE_KEY, 'true')
    setIsDefaultOpen(false)
    if (showLatestTour) {
      setShowLatestTour(false)
    }
  }

  return (
    <Dialog
      open={isDefaultOpen || showLatestTour}
      onOpenChange={handleGetStarted}
    >
      <Dialog.Content
        size="md"
        className="flex flex-col gap-8 pb-8"
        data-testid="initialPreviewOverlay"
      >
        <Dialog.Header>
          <Dialog.Title>The New DQL Editor</Dialog.Title>
          <Dialog.Description>
            Query your Ditto data using the new DQL syntax
          </Dialog.Description>
        </Dialog.Header>
        <FeatureHighlight
          title="Familiar SQL-like syntax"
          description="Write queries using a familiar SQL-like syntax. The new DQL syntax is designed to be easy to learn and use"
          icon={<Asterisk className="h-5 w-5" />}
        />

        <FeatureHighlight
          title="Filtering, sorting, and more"
          description="Immediate support for filtering, sorting, and offsets/limits"
          icon={<Filter className="h-5 w-5" />}
        />

        <FeatureHighlight
          title="Built-in data browser"
          description="The DQL Editor includes a built-in table that enables you to easily explore your data and test queries"
          icon={<Lightning className="h-5 w-5" />}
        />
        <Dialog.Footer>
          <Button
            variant="primary"
            onClick={handleGetStarted}
            className="w-full"
          >
            Get started
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
